/* eslint-disable max-len */
import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const RoutingIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M23.646 4.353a.5.5 0 0 1 .708 0l2.793 2.793a.5.5 0 0 1-.354.854H25v2.758c0 1.06-.422 2.078-1.172 2.828l-6.242 6.242A2 2 0 0 0 17 21.242V28h-2v-6.758a4 4 0 0 1 1.172-2.828l6.242-6.242A2 2 0 0 0 23 10.758V8h-1.793a.5.5 0 0 1-.353-.854l2.793-2.793Zm-15.999 0a.5.5 0 0 1 .707 0l2.793 2.793a.5.5 0 0 1-.354.854H9v2.758a2 2 0 0 0 .586 1.414l4.621 4.62-1.414 1.415-4.621-4.621A4.001 4.001 0 0 1 7 10.758V8H5.207a.5.5 0 0 1-.353-.854l2.793-2.793Z" />
  </BaseIcon>
);
